import { CommitteeConfigurationSortList } from 'src/screens/administration/configuration-management/committees-configuration/CommitteeConfigurationSortList'
import { PROCESS } from 'src/shared/constants/constants'

export const CommitteeConfigurationFactsheetPage = () => {
  return <CommitteeConfigurationSortList process={PROCESS.FACTSHEET} />
}
